module.exports = __webpack_public_path__ + "img/chocolatebar.5e6d5a80.png";